import userApi from '@/api/user'

const state = {
  data: null,
  isLoading: false,
  validationErrors: null,
  isSubmitting: false
}

export const mutationTypes = {
  getUserListStart: '[user] Get user start',
  getUserListSuccess: '[user] Get user success',
  getUserListFailure: '[user] Get user failure',
  updateUserStart: '[user] Update user shop start',
  updateUserSuccess: '[user] Update user shop success',
  updateUserFailure: '[user] Update user shop failure',
  logoutStart: '[user] Logout user start',
  logoutSuccess: '[user] Logout user success',
  logoutFailure: '[user] Logout user failure'
}

export const actionTypes = {
  getUserList: '[user] Get user',
  updateUser: '[user] Update user shop',
  logout: '[user] Logout user'
}

const mutations = {
  [mutationTypes.getUserListStart](state) {
    state.isLoading = true
    state.data = null
  },
  [mutationTypes.getUserListSuccess](state, payload) {
    state.isLoading = false
    state.data = payload
    state.validationErrors = null
  },
  [mutationTypes.getUserListFailure](state,payload) {
    state.isLoading = false
    state.validationErrors = payload
  },


  [mutationTypes.updateUserStart](state) {
    state.isLoading = true
  },
  [mutationTypes.updateUserSuccess](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },
  [mutationTypes.updateUserFailure](state,payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.logoutStart](state) {
    state.isLoading = true
  },
  [mutationTypes.logoutSuccess](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },
  [mutationTypes.logoutFailure](state,payload) {
    state.isLoading = false
    state.validationErrors = payload
  },


}

const actions = {
  [actionTypes.getUserList](context, data) {
    return new Promise(resolve => {
      context.commit(mutationTypes.getUserListStart)
      userApi
          .getUserList(data)
          .then(response => {
            context.commit(mutationTypes.getUserListSuccess, response)
            resolve(response)
          })
          .catch(response => {
            context.commit(mutationTypes.getUserListFailure,response)
          })
    })
  },

  [actionTypes.updateUser](context, data) {
    return new Promise(resolve => {
      context.commit(mutationTypes.updateUserStart)
      userApi
          .updateUser(data)
          .then(response => {
            context.commit(mutationTypes.updateUserSuccess, response)
            resolve(response)
          })
          .catch(response => {
            context.commit(mutationTypes.updateUserFailure,response)
          })
    })
  },

  [actionTypes.logout](context, data) {
    return new Promise(resolve => {
      context.commit(mutationTypes.logoutStart)
      userApi
          .logout(data)
          .then(response => {
            context.commit(mutationTypes.logoutSuccess, response)
            resolve(response)
          })
          .catch(response => {
            context.commit(mutationTypes.logoutFailure,response)
          })
    })
  },

}

export default {
  state,
  actions,
  mutations
}